// import $ from 'jquery';

const CB_DEFER_NONE = 0;
const CB_DEFER_PROCESS = 1;
const CB_DEFER_EXEC = 2;
const CB_DEFER_ALL = 3; // (CB_DEFER_PROCESS | CB_DEFER_EXEC)

// Start in queue mode
let callbacksEnabled = false;
let apiCallsEnabled = false;
const cbDeferMode = CB_DEFER_EXEC;

const allowedApiMethods = ['on', 'once', 'off', 'emit', 'push', 'setConfig'];

// Current callback stack
const callbackStack = {
	priority: {
		/** @type {string[]} */
		names: [],
		/** @type {{[key:string]: function[]}} */
		fns: {},
	},
	/** @type {function[]} */
	last: [],
	/** @type {{ name: string; args?: any[]; }[]} */
	apiCalls: [],
};

let cbsTimer;

/**
 * Push anything (but mostly callbacks :-))
 *
 * @param  {...any} args
 */
mpro.push = (...args) => {

	// Nothing to process
	if (args.length === 0) {
		return;
	}

	const { priority, last, apiCalls } = callbackStack;
	const { names, fns } = priority;
	let currentPriority;
	let currentApiCall;

	for (const arg of args) {

		// Priority specification
		if (typeof arg === 'string') {

			// There is already another priority spec enabled
			if (currentPriority) {
				console.warn('Invalid api.push argument: %o. There is a priority setting specified last and now a callback is expected...', arg);
				continue;
			}
			// There is an api call pending, expecting an arguments array
			else if (currentApiCall) {
				console.warn('Invalid api.push argument: %o. There is an api call specified last and now an arguments array is expected...', arg);
				continue;
			}

			// Priority specification (expect next argument to be a callback)
			if (arg.startsWith('priority')) {

				// Save the priority for the next callback
				currentPriority = arg;

				// Prepare the priority callback stack
				if (typeof fns[currentPriority] === 'undefined') {
					fns[currentPriority] = [];
					names.push(currentPriority);
				}
			}
			// Some api call (expect next argument to be array)
			else if (allowedApiMethods.includes(arg)) {
				currentApiCall = Object.create(null);
				currentApiCall.name = arg;
				apiCalls.push(currentApiCall);
			}
			else {
				console.warn('Invalid api.push argument: %o. Valid api calls are: %o', arg, allowedApiMethods);
				continue;
			}
		}
		// Some callback to execute later
		else if (typeof arg === 'function') {

			// There is an api call pending, expecting an arguments array
			if (currentApiCall) {
				console.warn('Invalid api.push argument: %o. There is an api call specified last and now an arguments array is expected...', arg);
				continue;
			}

			// Add to priority callbacks stack
			if (currentPriority != undefined) {
				fns[currentPriority].push(arg);
				currentPriority = undefined;
			}
			// Add to default callback stack
			else {
				last.push(arg);
			}
		}
		// Api call arguments
		else if (Array.isArray(arg)) {

			// Add args to the current api call
			if (currentApiCall) {
				currentApiCall.args = arg;
				// End current api call
				currentApiCall = undefined;
			}
			// Create a new api call
			else {
				currentApiCall = Object.create(null);
				// First arg must be the name of the api method
				currentApiCall.name = arg.shift();
				currentApiCall.args = arg;
				apiCalls.push(currentApiCall);
				currentApiCall = undefined;
			}
		}
		// Invalid argument type
		else {
			console.warn('Invalid api.push argument: %o. Expected a priority string, a callback function or an arguments array for an api call', arg);
		}
	}

	// We can start to process the api calls execution
	if (apiCallsEnabled === true) {
		apiCallsHandler();
	}

	// We can start the callbacks execution process
	if (callbacksEnabled === true) {
		// Defer callback process
		if (cbDeferMode & CB_DEFER_PROCESS) {
			cbsTimer && window.clearTimeout(cbsTimer);
			cbsTimer = window.setTimeout(cbsHandler);
		}
		// Process callbacks now
		else {
			cbsTimer && window.clearTimeout(cbsTimer);
			cbsHandler();
		}
	}
};

/**
 * Process all pending apiCalls and execute them
 */
const apiCallsHandler = () => {

	const { apiCalls } = callbackStack;

	// Process api calls first
	while (apiCalls.length > 0) {

		const apiCall = apiCalls.shift();

		// console.info('Next api call: %o', apiCall);

		// No defer is enabled for apiCalls
		try {
			// eslint-disable-next-line prefer-spread
			mpro[apiCall.name].apply(mpro, apiCall.args || []);
		}
		catch (error) {
			console.error('Error calling api method (mpro.%s) - apiCall: %o\n', apiCall.name, apiCall, error);
		}
	}
};

/**
 * Process all pending callbacks and execute them
 */
const cbsHandler = () => {

	const { priority, last } = callbackStack;
	const { names, fns } = priority;

	// Process callbacks
	if (names.length > 0) {

		// Intl string collator
		const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
		// Make sure priorities are in natural order
		names.sort(collator.compare);
		// names.sort((a, b) => a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' }));

		while (names.length > 0) {

			const name = names.shift();
			const fnsArr = fns[name];
			delete fns[name];

			// console.info('Calling', fnsArr.length, name, 'priority functions');
			while (fnsArr.length > 0) {
				// No defer is enabled for priority callbacks
				try {
					// console.info('Next priority callback call: %o', fnsArr[0]);
					// Note: relies on the global $ object to be available
					fnsArr.shift()($);
				}
				catch (error) {
					console.error('Error calling queued function\n', error);
				}
			}
		}
	}

	// console.info('Calling', last.length, 'delayed functions');
	while (last.length > 0) {
		try {
			const cb = last.shift();
			// console.info('Next callback call: %o', cb);
			// Defer callback execution
			if (cbDeferMode & CB_DEFER_EXEC) {
				// Note: relies on the global $ object to be available
				window.setTimeout(cb, undefined, $);
			}
			// Execute callback now
			else {
				// Note: relies on the global $ object to be available
				cb($);
			}
		}
		catch (error) {
			console.error('Error calling queued function\n', error);
		}
	}
	// console.info('Remaining functions', callbackStack);
};

/**
 * Pause the execution of apiCalls
 */
mpro.disableApiCalls = () => {
	// Enable the queue
	apiCallsEnabled = false;
};

/**
 * Resume the execution of apiCalls
 */
mpro.loadPendingApiCalls = () => {
	// Disable the queue
	apiCallsEnabled = true;
	// Run all queued callbacks
	apiCallsHandler();
};

/**
 * Pause the execution of callbacks
 */
mpro.disableCallbacks = () => {
	// Enable the queue
	callbacksEnabled = false;
};

/**
 * Resume the execution of callbacks
 */
mpro.loadPendingCallbacks = () => {
	// Disable the queue
	callbacksEnabled = true;
	// Run all queued callbacks
	cbsHandler();
};

export default mpro;
